import { useCallback } from 'react'
import { CHALLENGE_FLAG_KEY } from '@shared/challenge/types'
import { useAuth } from '../providers'
import { prefetchSendChallenge } from './send-challenge'
import { useLdFlag } from './useLdFlag'

export const DISABLE_CAPTCHA = process.env.DISABLE_CAPTCHA === 'true'

/** Whether sends carry an Arkose token. Dev builds opt out with `DISABLE_CAPTCHA`. */
export function useIsSendChallengeEnabled(): boolean {
  const isFlagOn = useLdFlag<boolean>(CHALLENGE_FLAG_KEY, false)
  return !DISABLE_CAPTCHA && isFlagOn
}

/** A callback for the composer to fire as the user types, so the send's token is ready by Enter. */
export function usePrefetchSendChallenge(): () => void {
  const isEnabled = useIsSendChallengeEnabled()
  const { getAuthToken } = useAuth()
  return useCallback(() => {
    if (isEnabled) prefetchSendChallenge(getAuthToken)
  }, [isEnabled, getAuthToken])
}
